/* eslint-disable react/no-danger */
import React, {
  useCallback,
  useEffect, useMemo, useRef, useState
} from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import bgConfirm from 'assets/images/bg-confirm-remake.jpg';
import getAllProvinces from 'services/locations/types';
import {
  imageLoader, wrapText
} from 'utils/functions';

const ConfirmRemake: React.FC = () => {
  const WIDTH = 1600;
  const HEIGHT = 2134;
  const TEXT_SIZE = 36;
  const TEXT_SIZE_NAME = 40;
  const TEXT_COLOR = '#fff';

  const [searchParams] = useSearchParams();
  const event = searchParams.get('event');
  const date = searchParams.get('date');
  const place = searchParams.get('place');
  const name = searchParams.get('name');
  const hospital = searchParams.get('hospital');
  const province = searchParams.get('province');
  const oldImage = searchParams.get('oldImage');

  const { data: provinceData } = useQuery(
    ['getAllProvincesMutate'],
    getAllProvinces,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const provinceOption: OptionType[] = useMemo(() => provinceData?.map((item) => ({
    label: item?.name || '',
    value: item?.code || '',
  })) || [], [provinceData]);
  const [imageRender, setImageRender] = useState<string>();

  const backgroundRef = useRef<HTMLImageElement | null>(null);
  const canvas = useMemo(() => {
    const c = document.createElement('canvas');
    c.width = WIDTH;
    c.height = HEIGHT;

    return c;
  }, []);
  const ctx = useMemo(() => canvas.getContext('2d')!, [canvas]);
  // const onhandleSubmit = () => {
  //   if (!confirmJoin || !isSigned || !checkinMethod || !handleSubmit) {
  //     setFirstTime(true);
  //     return;
  //   }
  //   canvas.toBlob(async (blob) => {
  //     if (blob) {
  //       const file = new File([blob], 'confirm.jpeg');
  //       const submitData = checkinMethod.getValues();
  //       handleSubmit({
  //         invitation_code: submitData.invitation_code || '',
  //         phone: submitData.phone,
  //         full_name: submitData.full_name,
  //         position_or_degree: submitData.position_or_degree,
  //         hospital: submitData.hospital,
  //         department: submitData.department,
  //         provinceCode: submitData.provinceCode?.value,
  //         dob: submitData.dob ? formatDDMMYYYY(submitData.dob) : undefined,
  //         signature: file,
  //       });
  //     }
  //   }, 'image/jpeg');
  // };

  const draw = useCallback(async () => {
    if (!backgroundRef.current) {
      const bg = await imageLoader(bgConfirm);
      backgroundRef.current = bg;
      ctx.drawImage(bg, 0, 0, WIDTH, HEIGHT);
    } else {
      ctx.drawImage(backgroundRef.current, 0, 0, WIDTH, HEIGHT);
    }

    ctx.font = `bold ${TEXT_SIZE}px 'Open Sans', sans-serif`;

    ctx.fillStyle = TEXT_COLOR;
    const title = (event || '').split('<br />');
    title.forEach((item: string, index: number) => {
      const textWidth = ctx.measureText(item).width;
      ctx.fillText(item.toUpperCase(), WIDTH / 2 - textWidth / 2 + 72, 495 + index * 50);
    });

    /// /// Draw time and location
    const timeText = `Thời gian: ${date || ''}`;
    const locationText = `Địa điểm: ${place || ''}`;
    ctx.fillText(timeText, WIDTH / 2 - (ctx.measureText(timeText).width) / 2, 660);
    ctx.fillText(locationText, WIDTH / 2 - (ctx.measureText(locationText).width) / 2, 715);

    ctx.font = `bold ${TEXT_SIZE_NAME}px 'Open Sans', sans-serif`;

    ctx.fillText((name || '').toUpperCase(), 460, 802);
    const wrappedText = wrapText(ctx, (hospital || '').toUpperCase(), 462, 868, WIDTH - 630, 56);
    wrappedText.forEach((item: any) => {
      ctx.fillText(item[0], item[1], item[2]);
    });
    const provincesText = provinceOption.find((item) => item.value === province)?.label || '';
    ctx.fillText(`TỈNH THÀNH: ${provincesText.toUpperCase()}`, 236, 932);

    // crop old image with
    if (oldImage) {
      const sign = await imageLoader(oldImage);

      ctx.drawImage(
        sign,
        230,
        1070,
        997,
        464,
        248,
        1450,
        1113,
        512
      );

      setImageRender(ctx.canvas.toDataURL('image/jpeg'));
    }
  }, [provinceOption]);

  useEffect(() => {
    draw();
  }, [draw]);

  return (
    <div className="p-confirmRemake">
      <img src={imageRender} />
      {/* create button download canvas */}
      <a
        href={imageRender}
        download={oldImage?.split('/').pop() || 'confirm-remake.jpeg'}
        className="btn-download"
        style={{
          display: imageRender ? 'block' : 'none',
          height: '50px',
          width: '200px',
          textAlign: 'center',
          lineHeight: '50px',
          backgroundColor: '#007bff',
          color: '#fff',
          borderRadius: '5px',
          textDecoration: 'none',
          fontSize: '18px',
          marginTop: '20px',
          marginBottom: '20px'
        }}
      >
        Tải xuống
      </a>
    </div>
  );
};

export default ConfirmRemake;
